import OtpCodeInput from './OtpCodeInput';

export { OtpCodeInput };
